module.exports = __webpack_public_path__ + "img/404.b4ccca82.jpg";